import React, { useState, useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { Navbar, Footer } from './components';
import { Home, PageNotFound } from './pages';

const App = () => {
    const { modeValue }     = useSelector((state) => state.modeList);
    const [theme, setTheme] = useState(modeValue);

    const toggleTheme = () => {
      setTheme(modeValue === "light" ? "dark" : "light");
    };
    
    useEffect(() => {
      setTheme(modeValue);
    }, [modeValue]);

    return (
      <div id={theme} className='main-container'>
        <Toaster position='top-center' reverseOrder="false" gutter={8} toastOptions={{ className: 'toast-option' }} containerStyle={{top: '15%', }}></Toaster>
        <Navbar toggleTheme={toggleTheme} theme={theme} />
        <Routes>
          <Route  path="/" exact element={<Home />} />
          <Route path='/page-not-found' exact element={<PageNotFound />} />
          <Route path="*" element={<Navigate to="/page-not-found" replace />} />
        </Routes>
        <Footer />
      </div>
    )
  }
  
  export default App